var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-login"},[_c('NavBar',{attrs:{"loginPage":"true"}}),_c('v-main',[_c('LoginForm',{attrs:{"afterRegistration":_vm.afterRegistration,"admin":true}})],1),_c('Footer',{attrs:{"absolute":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }